import { gql } from 'graphql-tag'

export const SUBSCRIPTION_CONVERSATION_TYPING_STATUS_USER_PRESENCE = gql`
  subscription ConversationTypingStatusUserPresence($key: String!) {
    user_presence(where: { key: { _eq: $key }, expired_at: { _gt: "now()" } }) {
      user_id
    }
  }
`

export const FRAGMENT_CONVERSATION_TYPING_STATUS_CONVERSATION = gql`
  fragment ConversationTypingStatusConversation on conversation {
    id
    conversation_users {
      user_id
      user {
        virtual_display_name
      }
    }
  }
`

export const FRAGMENT_CONVERSATION_TYPING_STATUS_MESSAGE = gql`
  fragment ConversationTypingStatusMessage on message {
    id
    user_id
    created_at
  }
`
